import { useTolgee } from '@tolgee/react';

import type { NotificationProps } from '~/shared/components/Notification';
import { useSessionInfo } from '~/shared/contexts';

import { useUpdateLanguage } from '../api';

export const useLanguageDropdown = (
  showNotification?: (notification: Omit<NotificationProps, 'onClose'>) => void
) => {
  const updateLanguage = useUpdateLanguage(showNotification);
  const { updateCurrentLanguage } = useSessionInfo();
  const tolgee = useTolgee();

  function handleLanguageChange(newLanguage: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem('currentLanguage', newLanguage);
    }

    void tolgee.changeLanguage(newLanguage);

    if (updateCurrentLanguage) {
      updateCurrentLanguage(newLanguage);
    }

    updateLanguage.mutate(newLanguage);
  }

  return {
    updateLanguage,
    handleLanguageChange
  };
};
